import { customerDomain } from 'domains/customer'
import React from 'react'

import ImportCustomerButton from '.'

export const ImportCustomerContainer = () => {
  return <ImportCustomerButton onCsvUpload={customerDomain.uploadCSVFile} />
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/ImportCustomerButton/container.js